/* eslint-disable no-use-before-define */
import {
  retrieveBrokerById,
  retrieveDistributionById,
  retrieveAffiliationsById,
  retrieveMembershipsById,
  retrieveIntegrationsById,
  retrieveAllCRMs,
  retrieveBrokerSettingsById,
  retrieveBrokerByUserId,
} from './apiRouterService';
import { getSocialLogin } from '../../../../app/src/legacy';
import i18n from '../../../../../i18n';
import cogoToast from 'cogo-toast';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

let brokerData, distributionData, brokerCRMName, distCRMName;

export async function retrieveBrokerId() {
  if (getSocialLogin() || isSocialLoginUrl) {
    const savedBrokerId = sessionStorage.getItem('broker_id');
    if (savedBrokerId) return savedBrokerId;
  }

  const [resp] = await retrieveBrokerById();
  return resp?.id;
}

/**
 * Get the broker's data
 *
 * @param  {String} [_brokerId]
 * @param  {Boolean} [shouldReset]
 */
export async function getBrokerData(_brokerId, shouldReset = false) {
  if (shouldReset) brokerData = undefined;
  if (brokerData) return brokerData;
  const brokerId = _brokerId || (await retrieveBrokerId());
  if (!brokerId) return;
  let _brokerData, status;
  if (_brokerId) {
    const [resp, _status] = await retrieveBrokerByUserId(brokerId);
    _brokerData = resp;
    status = _status;
  } else {
    const [resp, _status] = await retrieveBrokerById();
    _brokerData = resp;
    status = _status;
  }
  if (status === 200) {
    const { distribution_id, ...rest } = _brokerData;
    brokerData = { broker: { ...rest }, distribution_id };
    await getBrokerCRMName();
  }
  return brokerData;
}

export function resetBrokerData() {
  brokerData = undefined;
  distributionData = undefined;
  brokerCRMName = undefined;
}

export async function getBrokerDistribution(
  campaignDistiributionId,
  shouldReset = false,
) {
  // console.log(campaignDistiributionId);
  if (shouldReset) distributionData = undefined;
  if (distributionData) return distributionData;
  let distributionId = campaignDistiributionId;
  if (!campaignDistiributionId) {
    const { distribution_id } = (await getBrokerData()) || {};
    distributionId = distribution_id;
  }
  if (!distributionId) return distributionData;
  const [{ distribution }, status] = await retrieveDistributionById(
    distributionId,
  );
  if (status === 200) {
    distributionData = distribution;
  }
  return distributionData;
}

export async function getBrokerAffiliations() {
  // const [brokerResp, brokerStatus] = await retrieveBrokerById();
  const { broker } = await getBrokerData();
  const [resp, status] = await retrieveAffiliationsById(broker?.id);

  if (status > 201) {
    return cogoToast.error(i18n.t('Error when retrieving broker settings'));
  }

  return resp;
}

export async function getBrokerIntegrations() {
  const { broker } = await getBrokerData();
  // const [brokerResp, brokerStatus] = await retrieveBrokerById();
  const [{ integrations }, status] = await retrieveIntegrationsById(broker?.id);
  if (status > 201) {
    return cogoToast.error(i18n.t('Error when retrieving broker settings'));
  }
  return integrations;
}

export async function getBrokerSettings() {
  const { broker } = await getBrokerData();
  // const [brokerResp, brokerStatus] = await retrieveBrokerById();
  const [resp, status] = await retrieveBrokerSettingsById(broker?.id);

  if (status > 201) {
    return cogoToast.error(i18n.t('Error when retrieving broker settings'));
  }

  return resp;
}

export async function getBrokerMemberships() {
  const { broker } = await getBrokerData();
  // const [brokerResp, brokerStatus] = await retrieveBrokerById();
  const [{ memberships }, status] = await retrieveMembershipsById(broker?.id);

  if (status > 201) {
    return cogoToast.error(i18n.t('Error when retrieving broker settings'));
  }
  return memberships;
}

export async function getBrokerCRMName() {
  if (brokerCRMName) return brokerCRMName === `` ? null : brokerCRMName;
  const brokerData = await getBrokerData();
  const [_crmData, status] = await retrieveAllCRMs();
  if (status === 200) {
    const _brokerCRMKey = brokerData?.broker?.crm;
    const _crmNameDict = _crmData?.items.reduce((map, obj) => {
      map[obj?.broker_crm?.name] = obj?.broker_crm?.label;
      return map;
    }, {});
    const _brokerCRMName = Object.keys(_crmNameDict).includes(_brokerCRMKey)
      ? _crmNameDict[_brokerCRMKey]
      : null;
    brokerCRMName = _brokerCRMName;
  }
  return brokerCRMName;
}

export async function getDistributionCRMName(_distId) {
  if (distCRMName) return distCRMName === `` ? null : distCRMName;
  const distData = await getDistribution(_distId);
  const [_crmData, status] = await retrieveAllCRMs();
  // console.log({ distData });
  if (status === 200) {
    const _distCRMKey = distData?.crm;
    const _crmNameDict = _crmData?.items.reduce((map, obj) => {
      map[obj?.broker_crm?.name] = obj?.broker_crm?.label;
      return map;
    }, {});
    const _distCRMName = Object.keys(_crmNameDict).includes(_distCRMKey)
      ? _crmNameDict[_distCRMKey]
      : null;
    distCRMName = _distCRMName;
  }
  return distCRMName;
}

export async function getBrokerCRMKey(_brokerId) {
  const brokerData = await getBrokerData(_brokerId);
  return brokerData;
}

export async function getDistribution(distribution_id) {
  if (distributionData) return distributionData;
  if (!distribution_id) return distributionData;
  const [{ distribution }, status] = await retrieveDistributionById(
    distribution_id,
  );
  if (status === 200) {
    distributionData = distribution;
  }
  return distributionData;
}
